export type Measure = {
    type: MeasureType;
    week: MeasureWeek;
    value: number;
};

export type Measures = Measure[];

export const MeasureTypesMap = Object.freeze({
    Activity: "Activity",
    BriefPCS: "BriefPCS",
    Confidence: "Confidence",
    DASH: "DASH",
    FABQActivity: "FABQActivity",
    FABQTotal: "FABQTotal",
    FABQWork: "FABQWork",
    GAD7: "GAD7",
    KarunaRating: "KarunaRating",
    LEFS10: "LEFS10",
    MedicationReductionNew: "MedicationReductionNew",
    MedicationReductionOld: "MedicationReductionOld",
    Mood: "Mood",
    NDI: "NDI",
    Oswestry: "Oswestry",
    PCS: "PCS",
    PCSS: "PCSS",
    PHQ9: "PHQ9",
    PSEQ: "PSEQ",
    PSEQ2: "PSEQ2",
    Pain: "Pain",
    QuickDASH: "QuickDASH",
    ReturnToWorkOld: "ReturnToWorkOld",
    RPQ: "RPQ",
    RPQ3: "RPQ3",
    RPQ13: "RPQ13",
    Sleep: "Sleep",
    SocialFunction: "SocialFunction",
    UEFI: "UEFI",
    WHODAS: "WHODAS",
    WorkStatusImprovedNew: "WorkStatusImprovedNew",
    // Upper Extremity ROM Measures
    LeftAbduction: "LeftAbduction",
    LeftFlexion: "LeftFlexion",
    LeftScaption: "LeftScaption",
    RightAbduction: "RightAbduction",
    RightFlexion: "RightFlexion",
    RightScaption: "RightScaption",
    // Lower Back ROM Measures
    LowerFlexion: "LowerFlexion",
    // Neck ROM Measures
    NeckExtension: "NeckExtension",
    NeckFlexion: "NeckFlexion",
    NeckLeftRotation: "NeckLeftRotation",
    NeckRightRotation: "NeckRightRotation"
} as const);

export type MeasureType = keyof typeof MeasureTypesMap;
export type MeasureTypes = MeasureType[];

export enum MeasureCategory {
    PHYSICAL = 1,
    BEHAVIORAL = 2,
    UPPER_ROM = 3,
    LOWER_ROM = 4,
    NECK_ROM = 5,
    SOCIAL = 6,
    OTHER = 99
}

export type Month6TokenType = "M6";
export const Month6Token: Month6TokenType = "M6";

export type MeasureWeek = Month6TokenType | number;
